import { MappingTables } from '../types/mapping-tables.types';
import { DefaultRequiredColumnsTypes } from './default-required-columns-types.meta';
import { JobAndPayBankingColumnTypes } from './job-and-pay-banking-column-types.meta';
import { JobAndPayCompensationColumnTypes } from './job-and-pay-compensation-column-types.meta';
import { JobAndPayDefaultColumnTypes } from './job-and-pay-default-column-types.meta';
import { JobAndPayTerminationColumnTypes } from './job-and-pay-termination-column-types.meta';
import { PersonalAddressColumnsTypes } from './personal-address-columns-types.meta';
import { PersonalEmergencyContactColumnsTypes } from './personal-emergency-contact-columns-types.meta';
import { PersonalInformationColumnsTypes } from './personal-information-columns-types.meta';

export const EmployeeImporterMappingTables: MappingTables = {
    defaultRequired: {
        header: 'import.mappingTables.defaultRequired.header',
        description: 'import.mappingTables.defaultRequired.description',
        sections: {
            default: DefaultRequiredColumnsTypes,
        },
    },
    personal: {
        header: 'import.mappingTables.personal.header',
        description: 'import.mappingTables.personal.description',
        sections: {
            default: PersonalInformationColumnsTypes,
            address: PersonalAddressColumnsTypes,
            emergencyContact: PersonalEmergencyContactColumnsTypes,
        },
    },
    personalCustomFields: {
        header: 'import.mappingTables.personalCustomFields.header',
        description: 'import.mappingTables.personalCustomFields.description',
        isCustomFieldLocation: true,
        sections: null,
    },
    jobAndPay: {
        header: 'import.mappingTables.jobAndPay.header',
        description: 'import.mappingTables.jobAndPay.description',
        sections: {
            default: JobAndPayDefaultColumnTypes,
            banking: JobAndPayBankingColumnTypes,
            compensation: JobAndPayCompensationColumnTypes,
            termination: JobAndPayTerminationColumnTypes,
        },
    },
    jobAndPayCustomFields: {
        header: 'import.mappingTables.jobAndPayCustomFields.header',
        description: 'import.mappingTables.jobAndPayCustomFields.description',
        isCustomFieldLocation: true,
        sections: null,
    },
};
